module.exports = (Promise.resolve(__parcel__require__("./" + "Study.5ff9518c.js"))).then(() => parcelRequire('7zuJ6'));